module.exports = __webpack_public_path__ + "img/icon_min.27afed3d.svg";